import React, { useMemo } from 'react';

import { Flex } from '@adsk/alloy-react-box';
import { useLocale } from '@adsk/alloy-react-locale';
import StatusColorIndicator from '@adsk/alloy-react-status-color-indicator';

import { FORM_STATUSES, FEATURE_FLAGS } from './helpers/constants';
import { usePlangridFeatureFlag } from './PlangridLaunchDarklyProvider';

const FIELD_REPORT_STATUS_COLORS = {
  [FORM_STATUSES.ARCHIVED]: StatusColorIndicator.COLORS.GRAY_LIGHT,
  [FORM_STATUSES.IN_REVIEW]: StatusColorIndicator.COLORS.YELLOW,
  [FORM_STATUSES.DRAFT]: StatusColorIndicator.COLORS.GRAY_DARK,
  [FORM_STATUSES.SUBMITTED]: StatusColorIndicator.COLORS.GREEN,
};

const FormStatus = ({ status, statusColorIndicatorHeight }) => {
  const { value: isStatusExpansionEnabled } = usePlangridFeatureFlag(
    FEATURE_FLAGS.STATUS_EXPANSION,
    false,
  );
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  const translationsMap = useMemo(
    () => ({
      archived: T.translate('ARCHIVED'),
      draft: isStatusExpansionEnabled
        ? T.translate('IN_PROGRESS')
        : T.translate('DRAFT'),
      in_review: T.translate('IN_REVIEW'),
      submitted: isStatusExpansionEnabled
        ? T.translate('CLOSED')
        : T.translate('SUBMITTED'),
    }),
    [T, isStatusExpansionEnabled],
  );

  return (
    <Flex alignItems="center">
      <StatusColorIndicator
        statusColor={FIELD_REPORT_STATUS_COLORS[status]}
        style={{
          height: statusColorIndicatorHeight,
          width: 4,
          marginRight: 6,
        }}
      />
      <span>{translationsMap[status]}</span>
    </Flex>
  );
};

FormStatus.defaultProps = {
  statusColorIndicatorHeight: 16,
};

export default FormStatus;
